import { createFileRoute, notFound } from "@tanstack/react-router";
import { DirectoryNotFound, DirectoryPage } from "@/components/directory-page";
import { getAgentService } from "@/data/directory-pages";
import { filterDirectoryProviders } from "@/lib/directory";
import { directoryHead, type DirectoryPageData } from "@/lib/directory-seo";
import { getPublicProviders } from "@/lib/public-content.functions";

export const Route = createFileRoute("/makler_/leistungen/$leistung")({
  staticData: { sitemap: true },
  loader: async ({ params }): Promise<DirectoryPageData> => {
    const specialty = getAgentService(params.leistung);
    if (!specialty) throw notFound();
    const { providers, unavailable } = await getPublicProviders({
      data: { type: "immobilienmakler" },
    });
    return {
      kind: "agent",
      specialty,
      providers: filterDirectoryProviders(providers, undefined, specialty),
      unavailable,
    };
  },
  head: ({ loaderData }) => directoryHead(loaderData),
  notFoundComponent: DirectoryNotFound,
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  return <DirectoryPage key={data.specialty!.slug} {...data} />;
}
